import { createTamagui } from "tamagui";

import config from "../../libs/uikit/src/tamagui.config";

export const tamaguiConfig = createTamagui(config);

export default tamaguiConfig;

export type Conf = typeof tamaguiConfig;

declare module "tamagui" {
  //interface TamaguiCustomConfig extends Conf {}
}
